<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full" no-footer-line>
                <div slot="header">
                    <h4 class="card-title">Manage Today</h4>
                    <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div>

                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px"
                                v-model="pagination.perPage"
                                v-if="pagination"
                                placeholder="Per page"
                            >
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <n-button
                                @click.native="openModal()"
                                class="view ml-2"
                                type="primary"
                                size="sm"
                                round
                                icon
                                simple
                            >
                                <i class="fa fa-plus"></i>
                            </n-button>

                        </div>
                        
                        <div>
                            <fg-input
                                type="date"
                                name="date"
                                v-model="date">
                                <el-date-picker 
                                    @change="changeDate"
                                    v-model="date" 
                                    type="date" 
                                    format="M/d/yyyy"
                                    value-format="M/d/yyyy"
                                    placeholder="Pick a Date">
                                </el-date-picker>
                            </fg-input>
                        </div>
                    </div>
                    <el-table stripe style="width: 100%;" :data="queriedData" size="mini">
                        <el-table-column :min-width="135" :max-width="150" fixed="left" label="Image" align="left">
                            <div slot-scope="props" class="table-image">
                                <img :src="props.row.image" alt="">
                            </div>
                        </el-table-column>
                        <el-table-column
                            v-for="(column, index) in tableColumns"
                            :key="index"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            :sortable="column.sortable || false"
                            :align="column.align"
                            :header-align="column.align"
                            v-if="!column.hidden"
                            :fixed="column.fixed || false"
                            :formatter="column.formatter || null"
                        ></el-table-column>
                        
                        <el-table-column :min-width="135" fixed="right" label="Actions" align="right">
                            <div slot-scope="props" class="table-actions">
                                <!-- <n-button
                                    @click.native="handleView(props.$index, props.row)"
                                    class="view"
                                    type="primary"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-eye"></i>
                                </n-button> -->
                                <n-button
                                    @click.native="handleEdit(props.$index, props.row)"
                                    class="edit"
                                    type="warning"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-pencil"></i>
                                </n-button>
                                <n-button
                                    @click.native="handleDelete(props.$index, props.row)"
                                    class="remove"
                                    type="danger"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-times"></i>
                                </n-button>
                            </div>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- <div class="row">
                    <div class="col-md-2" v-for="(letter, index) in queriedData" :key="index">
                        <NoticeCard :letter="letter" @action-click="actionClick"></NoticeCard>
                    </div>
                </div> -->

                <div slot="footer" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                    <div> 
                        <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                    </div>
                    <n-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                    ></n-pagination>
                </div>
            </card>
        </div>

    </div>
</template>

<script>
import { Select, Option, DatePicker, Table, TableColumn } from "element-ui";
import { Pagination as NPagination, NoticeCard } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";

import { mapGetters } from 'vuex';

export default {
    components: {
        NPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        NoticeCard,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    computed: {
        ...mapGetters({
            tableData: 'getToday',
            topics: 'getTopics',
            preferences: 'getPreferences',
            authTokens: 'getAuthTokens',
        }),

        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.searchedData;
            // if (this.searchedData.length > 0) {
            //     result = this.searchedData;
            // }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
        }
    },
    data() {
        return {
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: [ "title", "venue", "organised_by", "date_time" ],
            tableColumns: [
                {
                    prop: "_id",
                    label: "ID",
                    hidden: true,
                    minWidth: 200,
                },
                {
                    prop: "title",
                    label: "Ttile",
                    minWidth: 150,
                    align: 'left',
                    sortable: true,
                    fixed: false
                },
                {
                    prop: "venue",
                    label: "Venue",
                    minWidth: 300,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "organised_by",
                    label: "Organised By",
                    minWidth: 300,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "date_time",
                    label: "Date & Time",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        let d = new Date(cellValue)
                        return d.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' })
                    }
                },
            ],
            searchedData: [],
            fuseSearch: null,
            date: (new Date()).toLocaleDateString('en-US'),
            filterMethod(query, item) {
                return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            }
        };
    },
    methods: {
        openModal(){
            if(this.tableData.length == 0){
                // if no todays are available for the day
                // goto create page
                this.$router.push('/glimpses/today/compose');
            }
            else{
                // if atleast one today is available for the day
                // to go update page
                this.$router.push(`/glimpses/today/edit/${this.date.split("/").join("-")}`)
            }
        },
        
        changeDate(){
            this.$store.dispatch('getTodayByDate', {date: this.date});
        },
        handleView(index, row) {
            this.$router.push(`/glimpses/today/view/${newsletter._id}`)
        },
        handleEdit(index, row) {
            this.$router.push(`/glimpses/today/edit/${this.date.split("/").join("-")}`)
        },
        handleDelete(index, row) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Delete it!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.deleteRow(row);
                }
            });
        },
        deleteRow(row) {
            this.$store.dispatch('deleteToday', {today: row._id, date: this.date})
        },
    },
    mounted() {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: this.propsToSearch,
            threshold: 0.1
        });

        this.$nextTick(() => {
            this.pagination.perPage = this.preferences.perPage
        })

        this.$store.dispatch('getTodayByDate', {date: this.date});
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery: {
            handler: function(value){
                let result = Object.assign([], this.tableData);
                if (value !== "") {
                    result = this.fuseSearch.search(value);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        tableData: {
            handler: function(value){
                this.fuseSearch = new Fuse(value, {
                    keys: this.propsToSearch,
                    threshold: 0.1
                })
                let result = Object.assign([], value);
                if (this.searchQuery !== "") {
                    result = this.fuseSearch.search(this.searchQuery);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        'pagination.perPage'(value){
            this.preferences.perPage = value
            this.$store.commit('setPreferences', this.preferences)
        }
    }
};
</script>
<style lang="scss">
    .has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }
</style>

